export const getLocaleFromUrl = (url: string): string | null | undefined => {
  if (!url) return null;

  try {
    const locale = url.split('/')[1];

    if (/^[a-z]{2}-[A-Z]{2}$/.test(locale as string)) {
      return locale;
    }

    return null;
  } catch (error) {
    return null;
  }
}
